import { AlertFilter } from './types'

export const createOrUpdateAlertFilter = (alertFilter: AlertFilter) =>
  ({ type: 'alertFilter.createOrUpdate', payload: { alertFilter } } as const)
export type CreateOrUpdateAlertFilterAction = ReturnType<
  typeof createOrUpdateAlertFilter
>

export const createOrUpdateAlertFilterSuccess = (response: number) =>
  ({
    type: 'alertFilter.createOrUpdateSuccess',
    payload: { response }
  } as const)

export const muteAlertFilter = (id: number, mute: boolean) =>
  ({ type: 'alertFilter.muteAlertFilter', payload: { id, mute } } as const)
export type MuteAlertFilterAction = ReturnType<typeof muteAlertFilter>

export const muteAlertFilterSuccess = (filter: AlertFilter) =>
  ({ type: 'alertFilter.muteAlertFilterSuccess', payload: { filter } } as const)
type MuteAlertFilterSuccessAction = ReturnType<typeof muteAlertFilterSuccess>

export const alertFilterFailure = () =>
  ({ type: 'alertFilter.failure' } as const)
type AlertFilterFailure = ReturnType<typeof alertFilterFailure>

export const deleteAlertFilter = (id: number) =>
  ({ type: 'alertFilter.deleteAlertFilter', payload: { id } } as const)
export type DeleteAlertFilterAction = ReturnType<typeof deleteAlertFilter>

export const deleteAlertFilterSuccess = (id: number) =>
  ({ type: 'alertFilter.deleteAlertFilterSuccess', payload: { id } } as const)
type DeleteAlertFilterSuccessAction = ReturnType<
  typeof deleteAlertFilterSuccess
>

export const fetchAlertFilters = () =>
  ({ type: 'alertFilter.fetchAlertFilters' } as const)
type FetchAlertFilters = ReturnType<typeof fetchAlertFilters>

export const fetchAlertFiltersSuccess = (alertFilters: AlertFilter[]) =>
  ({
    type: 'alertFilter.fetchAlertFiltersSuccess',
    payload: { alertFilters }
  } as const)
type FetchAlertFiltersSuccess = ReturnType<typeof fetchAlertFiltersSuccess>

export type AlertFilterAction =
  | FetchAlertFilters
  | FetchAlertFiltersSuccess
  | DeleteAlertFilterAction
  | DeleteAlertFilterSuccessAction
  | MuteAlertFilterAction
  | MuteAlertFilterSuccessAction
  | AlertFilterFailure
  | CreateOrUpdateAlertFilterAction
